export default __webpack_public_path__ + "3c990b720794caa91d870be0b403c5bc.png";